import React, { Fragment, useState } from "react";

function UiMainWrapper(props) {
  return <div className="dl-inner-main-wraper" {...props} />;
}

export default UiMainWrapper;
